import { Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { Logo } from "@/components/brand";

import { AppShell, NavGroup, NavItem } from "@/components/ui";

import "../publisher.css";

const SECTIONS = [
  { id: "versions", label: "Versions", to: "/publisher" },
  { id: "validation", label: "Validation", to: "/publisher/validation" },
  { id: "listing", label: "Listing", to: "/publisher/listing" },
  { id: "namespace", label: "Namespace", to: "/publisher/namespace" },
  { id: "tokens", label: "Publish tokens", to: "/publisher/tokens" },
] as const;

type PublisherPath = (typeof SECTIONS)[number]["to"] | "/console/home";

/** The frame every publisher screen renders inside. One application, one audience. */
export function PublisherShell() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  const go = (to: PublisherPath) => (event: { preventDefault: () => void }) => {
    event.preventDefault();
    void navigate({ to });
  };

  const nav = (
    <NavGroup label="Publisher">
      {SECTIONS.map((section) => (
        <NavItem
          key={section.id}
          href={section.to}
          active={section.to === "/publisher" ? pathname === section.to : pathname.startsWith(section.to)}
          onClick={go(section.to)}
        >
          {section.label}
        </NavItem>
      ))}
    </NavGroup>
  );

  return (
    <AppShell
      railLabel="Publisher"
      brand={<Logo size={22} />}
      nav={nav}
      railFooter={
        <NavItem href="/console/home" onClick={go("/console/home")}>
          Console
        </NavItem>
      }
    >
      <Outlet />
    </AppShell>
  );
}
